export const STOCKS_DETAIL_PERMISSION = Object.freeze({
  VIEW: 'ST_STOCKSDETAIL_VIEW',
  SALES_INVENTORY_VIEW: 'ST_SALES_INVENTORY_VIEW',
  TRANSFER_MONITOR_VIEW: 'ST_INVENTORY_TRANSFER_MONITOR_VIEW',
  INVENTORY_COST_CORRECTION: 'ST_INVENTORY_COST_CORRECTION',
  INVENTORY_COST_VALUE_VIEW: 'ST_INVENTORY_COST_VALUE_VIEW',
  COST_CORRECT: 'ST_INVENTORY_COST_COST_CORRECT',
  IMEI_CORRECT: 'ST_INVENTORY_COST_IMEI_CORRECT',
  CORRECTION_HISTORY_VIEW: 'ST_INVENTORY_COST_HISTORY_VIEW',
  HOLD_RELEASE: 'ST_STOCKSDETAIL_HOLD_RELEASE',
  DELETE: 'ST_STOCKSDETAIL_DEL',
  EXPORT: 'ST_STOCKSDETAIL_EXPORT',
  COGS_VIEW: 'COGS_VIEW',
  COGS_CALCULATE: 'COGS_CALCULATE',
  COGS_SETTINGS: 'COGS_SETTINGS',
});
